let window;
if (typeof window === 'undefined') {
  window = global;
}

/**
 * Wrap a function in a caller function if it's on window
 *
 * @param  {Function} fn the function to wrap
 * @return {Function} the wrapped function
 */
function _createWindowFunctionWrapper(fn) {
  if (fn === window.setTimeout) {
    return function(wrapped, time) {
      return window.setTimeout(wrapped, time);
    };
  } else if (fn === window.setInterval) {
    return function(wrapped, time) {
      return window.setInterval(wrapped, time);
    };
  } else if (fn === window.clearTimeout) {
    return function(id) {
      return window.clearTimeout(id);
    };
  } else if (fn === window.clearInterval) {
    return function(id) {
      return window.clearInterval(id);
    };
  } else {
    return fn;
  }
}

/**
 * Replaces the window timer functions with ones that will wrap the
 * function argument and provide a way to name the function.
 *
 * @param {string} prefix default name of the
 * @param {function (this:Window, ...?): ?}
 *    oldFunc
 * @return {Function}
 *    A replacement function for the window timer function that takes an extra
 *    name parameter.
 */
const wrapWindowTimeFns = function(prefix, oldFunc) {
  const newFn = _createWindowFunctionWrapper(oldFunc);

  /**
   * Updated version of the window time function.
   *
   * @this {Window}
   * @param {Function|null|string} fn Function.
   * @param {number} time Time in milliseconds.
   * @param {...string} name Custom name.
   * @return {number}
   */
  const callback = function(fn, time, name, ...args) {
    return newFn(fn, time, name, ...args);
  };

  return callback;
};

const timer = {
  setTimeout: wrapWindowTimeFns('setTimeout', window.setTimeout),
  setInterval: wrapWindowTimeFns('setInterval', window.setInterval),
  clearTimeout: wrapWindowTimeFns('clearTimeout', window.clearTimeout),
  clearInterval: wrapWindowTimeFns('clearInterval', window.clearInterval),
};

export default timer;
